import { useCallback, useState } from "react";

export function usePendingSet<Id extends string | number = string | number>() {
	const [pendingSet, setPendingSet] = useState<Set<Id>>(new Set());

	const setItemPending = useCallback((id: Id, pending: boolean) => {
		setPendingSet((prev) => {
			const next = new Set(prev);
			pending ? next.add(id) : next.delete(id);
			return next;
		});
	}, []);

	const isPending = useCallback((id: Id) => pendingSet.has(id), [pendingSet]);

	const clearPending = useCallback(() => setPendingSet(new Set()), []);

	return { pendingSet, isPending, setItemPending, clearPending };
}
